var pseudoSelectors = ["before", "after"];
function getBrowserStyles(rootNode, selectorPrefix, stylesheetFilter) {
    var stylesArray = [];
    var pseudos = pseudoSelectors.map(function (p) {
        return {
            type: p,
            regex: new RegExp("(.*?)::?" + p + "$"),
        };
    });
    var styleSheets = rootNode.styleSheets;
    if (stylesheetFilter) {
        styleSheets = Array.from(styleSheets).filter(stylesheetFilter);
    }
    var pseudo, selector;
    function eachPseudo(pseudoInfo) {
        if (pseudo)
            return;
        var match = selector.match(pseudoInfo.regex);
        if (match) {
            selector = match[1];
            pseudo = pseudoInfo.type;
        }
    }
    for (var i = 0; i < styleSheets.length; i++) {
        try {
            var rules = styleSheets[i].cssRules;
            if (!rules)
                continue;
            for (var j = 0; j < rules.length; j++) {
                if (rules[j].type !== 1)
                    continue;
                var selectors = rules[j].selectorText.trim().split(/\s*,\s*/g);
                var declarations = {};
                var cssStyle = rules[j].style;
                var k;
                for (k = 0; k < cssStyle.length; k++) {
                    declarations[cssStyle[k]] = cssStyle[cssStyle[k]];
                }
                for (k = 0; k < selectors.length; k++) {
                    if (!selectorPrefix || selectors[k].indexOf(selectorPrefix) === 0) {
                        selector = selectors[k];
                        pseudo = null;
                        pseudos.forEach(eachPseudo);
                        stylesArray.push({
                            selector: selector,
                            declarations: declarations,
                            pseudo: pseudo,
                        });
                    }
                }
            }
        }
        catch (e) {
            // Do nothing
        }
    }
    return stylesArray;
}
module.exports = getBrowserStyles;
//# sourceMappingURL=module.js.map